import React from 'react';
import { NOTIFICATION_TYPES} from '../../helpers/constants';
import ReactTable from 'react-table';
import moment from 'moment';
import * as sanitizeHtml from 'sanitize-html';
import {Button} from 'reactstrap';

import {I18n} from '../../I18n/components/alerts';
import Pagination from '../Pagination/Pagination';

import './notificationsList.css';

const PAGINATION_DEFAULT_LIMIT = 25;

function strip(html){
	var doc = new DOMParser().parseFromString(html, 'text/html');
	return doc.body.textContent || "";
}

const NotificationsList = props => {
	const notes = props.data && props.data.notifications ? props.data.notifications : [];
	let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
	const tableData = notes.map((note, index) => {
		const dto = note.updateInfo ? note.updateInfo : null;
		return {
			count_id: firstElementNumber++,
			id: note.id,
			note: {
				uploadedApkName: dto.title ? dto.title : 'none',
			},
			version: {
				uploadedApkVersion: dto.versionString ? dto.versionString : 'none',
				previousVersion: note.previousApkVersion,
			},
			type: note.type,
			actions: {
				type: note.type,
				id: note.id
			},
			lastActivity: note.creationDate ? moment(note.creationDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : 'none'
		};
	});
	return (
		<div className="alerts-note-table MyReactTableClass">
			<ReactTable
				getProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							border: "none",
							padding: "5px"
						}
					};
				}}
				getTheadProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							boxShadow: "none",
							padding: "10px 0",
							fontWeight: "600"
						}
					};
				}}
				getTheadThProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							borderRight: "none"
						}
					};
				}}
				getTdProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							borderRight: "none",
							textAlign: "center"
						}
					};
				}}
				getTrProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							alignItems: "center"
						}
					};
				}}
				getNoDataProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							top: "100%"
						}
					};
				}}
				columns={[
					{
						Header: "#",
						accessor: "count_id",
						sortable: false,
						filterable: false,
						style: {
							textAlign: "left",
							fontSize: "0.6rem",
							textTransform: "lowercase"
						},
						maxWidth: 40
					},
					{
						Header: `${I18n[props.lang].app}`,
						accessor: "note",
						sortable: true,
						filterable: false,
						minWidth: 300,
						style: {
							textAlign: "left",
							fontSize: "0.8rem",
						},
						Cell: row => (
							<div className="alerts-note-table__row">
								<div className="note-item">
									<div className="note-item__info-title"> {row.value.uploadedApkName} </div>
								</div>
							</div>
						)
					},
					{
						Header: `${I18n[props.lang].version}`,
						accessor: "version",
						sortable: false,
						filterable: false,
						style: {
							textAlign: "center",
							fontSize: "0.8rem",
							textTransform: "lowercase"
						},
						minWidth: 200,
						Cell: row => (
							<div className="alerts-note-table__row">
								<div className="note-item">
									<div className="note-item__info-version"> {row.value.previousVersion} => {row.value.uploadedApkVersion} </div>
								</div>
							</div>
						)
					},
					// {
					// 	Header: "",
					// 	accessor: "actions",
					// 	sortable: false,
					// 	filterable: false,
					// 	minWidth: 70,
					// 	Cell: row => false ? (//row => row.value.type === NOTIFICATION_TYPES.NEW ? (
					// 		<div className="text-center">
					// 			<Button
					// 				onClick={() => props.updateHandler(row.value.id)}
					// 				color="primary"
					// 				size="sm"
					// 				round="true"
					// 				disabled={row.value.type !== NOTIFICATION_TYPES.NEW}
					// 			>
					// 				<i className="fa fa-check"/>
					// 			</Button>
					// 			<Button
					// 				onClick={() => {props.declineHandler(row.value.id)}}
					// 				className="ml-1"
					// 				color="secondary"
					// 				size="sm"
					// 				round="true"
					// 				disabled={row.value.type !== NOTIFICATION_TYPES.NEW}
					// 			>
					// 				<i className="fa fa-times"/>
					// 			</Button>
					// 		</div>
					// 	) : null
					// },
					{
						Header: `${I18n[props.lang].status}`,
						accessor: "type",
						sortable: true,
						filterable: false,
						width: 80,
						style: {
							textAlign: "center",
							fontSize: "0.7rem",
						},
						Cell: row => (
							<div className="note-item__status">
										<span style={{
											background: row.value.type === NOTIFICATION_TYPES.DECLINED ? '#f62d51'
												: row.value === NOTIFICATION_TYPES.OUTDATED ? '#8898aa'
													: row.value === NOTIFICATION_TYPES.ACCEPTED ? '#D5D502'
														: row.value === NOTIFICATION_TYPES.NEW ? '#D56D00'
															: row.value === NOTIFICATION_TYPES.UPDATED ? '#57D500': '#000000',
											padding: "3px 5px",
											borderRadius: "45px",
											color: "#ffffff"
										}}>
										{
											row.value === NOTIFICATION_TYPES.DECLINED ? `${I18n[props.lang].statusDeclined}` :
												row.value === NOTIFICATION_TYPES.OUTDATED ? `${I18n[props.lang].statusOutdated}` :
													row.value === NOTIFICATION_TYPES.ACCEPTED ? `${I18n[props.lang].statusAccepted}` :
														row.value === NOTIFICATION_TYPES.NEW ? `${I18n[props.lang].statusNew}` :
															row.value === NOTIFICATION_TYPES.UPDATED ? `${I18n[props.lang].statusUpdated}` :
																`${I18n[props.lang].noStatus}`
										}
										</span>
							</div>
						)
					},
					{
						Header: `${I18n[props.lang].time}`,
						accessor: "lastActivity",
						sortable: false,
						filterable: false,
						style: {
							textAlign: "center",
							fontSize: "0.8rem",
							textTransform: "lowercase"
						},
						maxWidth: 90
					},
				]}
				PaginationComponent={Pagination}
				nextText={">>"}
				previousText={"<<"}
				defaultPageSize={-1}
				pageSize={tableData.length}
				showPaginationBottom={props.totalPages > 1 ? true : false}
				className="-highlight"
				data={tableData}
				manual
				onPageChange={props.setCurrentPage}
				page={props.currentPage}
				pages={props.totalPages}
			/>
		</div>
	)
};

export default NotificationsList;



// WEBPACK FOOTER //
// ./src/components/Alerts/NotificationsList.js